// assets
import { IconAddressBook, IconBrandX, IconChartFunnel, IconFileInvoice, IconMail, IconReportAnalytics, IconUsersGroup } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - GROWTH (P2-2) ||============================== //

const growth: NavItemType = {
  id: 'growth',
  title: 'growth', // react-intl key - i18n-ready [STD-DRIFT]
  icon: IconUsersGroup,
  type: 'group',
  requiredModule: 'growth',
  children: [
    {
      id: 'growth-contacts',
      title: 'growth-contacts',
      icon: IconAddressBook,
      type: 'item',
      url: '/growth/contacts',
      module: 'growth.contacts'
    },
    {
      id: 'growth-crm',
      title: 'growth-crm',
      icon: IconChartFunnel,
      type: 'item',
      url: '/growth/crm',
      module: 'growth.crm'
    },
    {
      // SALES (Commerce mig 743): quotes live in Commerce but are worked from CRM, so they sit right after it.
      id: 'growth-quotes',
      title: 'growth-quotes',
      icon: IconFileInvoice,
      type: 'item',
      url: '/commerce/quotes',
      module: 'commerce.quotes',
      requiredModule: 'commerce'
    },
    {
      // SALES S7 (Growth mig 758): the salesperson scorecard and targets — growth.sales_performance.menu (D18, D19).
      id: 'growth-sales-performance',
      title: 'growth-sales-performance',
      icon: IconReportAnalytics,
      type: 'item',
      url: '/growth/sales-performance',
      module: 'growth.sales_performance'
    },
    {
      id: 'growth-campaigns',
      title: 'growth-campaigns',
      icon: IconMail,
      type: 'item',
      url: '/growth/campaigns',
      module: 'growth.campaigns'
    },
    {
      id: 'growth-social',
      title: 'growth-social',
      icon: IconBrandX,
      type: 'item',
      url: '/growth/social',
      module: 'growth.social'
    }
  ]
};

export default growth;
